export const tepCriteria = [
  { id: 't1', label: 'Sinais clínicos de TVP (edema objetivo da perna e dor à palpação profunda)', points: 3.0 },
  { id: 't2', label: 'TEP considerada mais provável que diagnóstico alternativo', points: 3.0 },
  { id: 't3', label: 'Frequência cardíaca > 100 bpm', points: 1.5 },
  { id: 't4', label: 'Imobilização recente (≥ 3 dias) ou cirurgia nas últimas 4 semanas', points: 1.5 },
  { id: 't5', label: 'Antecedente de TVP ou TEP', points: 1.5 },
  { id: 't6', label: 'Hemoptise', points: 1.0 },
  { id: 't7', label: 'Malignidade ativa (tratamento nos últimos 6 meses ou paliativo)', points: 1.0 },
];

export const tvpCriteria = [
  { id: 'd1', label: 'Câncer ativo (tratamento em andamento, nos últimos 6 meses ou paliativo)', points: 1 },
  { id: 'd2', label: 'Paresia, paralisia ou imobilização gessada recente do membro inferior', points: 1 },
  { id: 'd3', label: 'Imobilização no leito por ≥ 3 dias ou cirurgia de grande porte nas últimas 12 semanas', points: 1 },
  { id: 'd4', label: 'Dor localizada ao longo da distribuição do sistema venoso profundo', points: 1 },
  { id: 'd5', label: 'Edema de todo o membro inferior', points: 1 },
  { id: 'd6', label: 'Diferença de circunferência da panturrilha > 3 cm (comparada à perna assintomática)', points: 1, hint: 'Medir 10 cm abaixo da tuberosidade tibial. Não invente valores se não foi medido.' },
  { id: 'd7', label: 'Edema depressível (cacifo) confinado à perna sintomática', points: 1 },
  { id: 'd8', label: 'Veias colaterais superficiais (não varicosas)', points: 1 },
  { id: 'd9', label: 'TVP prévia documentada', points: 1 },
  { id: 'd10', label: 'Diagnóstico alternativo tão ou mais provável que TVP', points: -2, isNegative: true },
];
